import { useEffect, useRef, type ReactNode } from "react";
import { SaveBar } from "@shopify/app-bridge-react";

interface AppBridgeSaveBarProps {
	id: string;
	open: boolean;
	discardConfirmation?: boolean;
	children: ReactNode;
}

export function AppBridgeSaveBar({
	discardConfirmation = false,
	...props
}: AppBridgeSaveBarProps) {
	const ref = useRef<UISaveBarElement | null>(null);

	useEffect(() => {
		if (ref.current) {
			ref.current.discardConfirmation = discardConfirmation;
		}
	}, [discardConfirmation]);

	return <SaveBar ref={ref} {...props} />;
}
